import { CloudUpload } from "@mui/icons-material";
import { Box, Stack, Typography } from "@mui/material";

const DropZone = ({
  isDragging,
  handleDragOver,
  handleDragLeave,
  handleDrop,
  handleFileInput,
  theme,
}) => (
  <Box
    onDragOver={handleDragOver}
    onDragLeave={handleDragLeave}
    onDrop={handleDrop}
    sx={{
      border: `2px dashed ${
        isDragging ? theme.palette.primary.main : theme.palette.divider
      }`,
      borderRadius: 2,
      p: { xs: 1, sm: 4 },
      textAlign: "center",
      cursor: "pointer",
      transition: "0.3s",
      bgcolor: isDragging ? "hsl(var(--accent) / 0.1)" : "transparent",
      "&:hover": {
        borderColor: theme.palette.primary.main,
        bgcolor: "hsl(var(--accent) / 0.05)",
      },
      display: "flex",
      flexDirection: "column",
      alignItems: "center",
      justifyContent: "center",
      minHeight: "400px",
      gap: 1.5,
    }}
    onClick={() => document.getElementById("file-input")?.click()}
  >
    <Stack
      sx={{
        backgroundColor: theme.palette.background.textField,
        borderRadius: "100%",
        height: 70,
        width: 70,
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
      }}
    >
      <CloudUpload
        sx={{
          fontSize: 44,
          color: theme.palette.primary.main,
        }}
      />
    </Stack>
    <Typography
      sx={{
        fontSize: { xs: "1em", sm: "1.2rem" },
        fontWeight: 500,
        lineHeight: 1.4,
        letterSpacing: "0.02em",
      }}
    >
      Arraste e solte o arquivo aqui
    </Typography>
    <Typography variant="body2" color="text.secondary">
      ou clique para selecionar o arquivo
    </Typography>

    <input
      id="file-input"
      type="file"
      accept=".csv"
      style={{ display: "none" }}
      onChange={handleFileInput}
    />
  </Box>
);

export { DropZone };
